//
//
//
//
//
//
//
//
//
//
//
import DeviceInfoList from "../device/DeviceInfoList";
export default {
  components: {
    DeviceInfoList: DeviceInfoList
  },
  data: function data() {
    return {
      tabKeys: "7"
    };
  },
  created: function created() {
    this.tabKeys = "7";
  },
  computed: {},
  methods: {}
};